import { render, staticRenderFns } from "./FlagBadge.vue?vue&type=template&id=72bb5079&"
import script from "./FlagBadge.vue?vue&type=script&lang=js&"
export * from "./FlagBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports